// extracted by mini-css-extract-plugin
export default {"CompanyInfo":"styles_CompanyInfo__7lNdr","CompanyInfoCustomer":"styles_CompanyInfoCustomer__Y1w5Y","CompanyInfoValue":"styles_CompanyInfoValue__jxsFq"};